import type { SetI18nMessage } from '../types';

export const i18nData: SetI18nMessage = {
  backToOverview: 'Back to Overview',
  dateAndTime: 'Date and Time',
  enablePhotoPreviews: 'Enable Photo Previews',
  errorConfigurationLoad:
    'We were unable to load the configuration data. Please try again or contact us if you continue to experience issues.',
  photoPreviews: 'Photo Previews',
  photoPreviewsHelp:
    'When enabled, photo icons will appear above seats with a preview. Click the icon to see the view from that seat.',
  priceTypes: {
    1: 'Standard',
    2: 'VIP'
  },
  section: 'Section',
  sections: {
    balcony: 'Balcony',
    mezzanine: 'Mezzanine',
    'orchestra-front': 'Orchestra Front',
    'orchestra-rear': 'Orchestra Rear'
  },
  zones: {
    23: 'Orchestra Front',
    24: 'Orchestra Rear',
    25: 'Mezzanine',
    26: 'Balcony'
  },
  type: 'SET_I18N'
};
